import FormContainer from "shared/form";
import { FormikProps } from "formik";
import FormRadioField from "shared/form/fields/radioField";
import { CouponCodeFormFieldsName } from "./enum";
import { RadioOptionsDisplayStyle } from "shared/form/enum";
import FormTextField from "shared/form/fields/textField";
import Button from "shared/components/button";
import ButtonType from "shared/enums/ButtonTypes";
import useCouponCodeFlowService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import { CouponCodeFlowPropsType } from "./type";
import { AnyObject } from "../../../../global";
import { BooleanOption } from "../../../../shared/enums/BooleanOption";

export default function CouponCodeFlow(props: CouponCodeFlowPropsType) {
  const copies = useCopies();
  const service = useCouponCodeFlowService(props);
  return (
    <div className="buyInventory_cardWrapper buyTicket_formGroup">
      <FormContainer
        innerRef={service.formRef}
        initialValues={service.initialValues}
        onSubmit={service.submitHandler}
        validationSchema={service.validationSchema}
        enableReinitialize>
        {({ values }: FormikProps<AnyObject>) => (
          <FormContainer.Form className="buyTicket_formGroup--coupon">
            <FormRadioField
              label={copies.get("have.coupon.code")}
              options={service.haveCouponCodeOptions}
              name={CouponCodeFormFieldsName.HAVE_COUPON_CODE}
              displayStyle={RadioOptionsDisplayStyle.HORIZONTAL}
              onChange={(e: any) => service.haveCouponCodeChangeHandler(e.target.value)}
            />
            {values.haveCouponCode === BooleanOption.YES && (
              <div className="buyTicket_applyCouponCode">
                <FormTextField
                  required={true}
                  resetFieldWhenRemoved={true}
                  label={copies.get("coupon.code")}
                  name={CouponCodeFormFieldsName.COUPON_CODE}
                />
                <Button className="stylizedLargeBtn" label={copies.get("apply")} type={ButtonType.SUBMIT} />
              </div>
            )}
            {values.haveCouponCode === BooleanOption.NO && (
              <Button
                className="continueBtn"
                label={copies.get("continue")}
                onClick={() => service.haveCouponCodeChangeHandler(BooleanOption.NO)}
              />
            )}
          </FormContainer.Form>
        )}
      </FormContainer>
    </div>
  );
}
